import React from 'react'
import { GridColumnsManagement, GridPanelWrapper, useGridApiContext, useGridRootProps } from '@mui/x-data-grid'
import { Button, Box } from '@mui/material'

const ColumnsPanel = ({ defaults, ...props }) => {
  const apiRef = useGridApiContext()
  const rootProps = useGridRootProps()

  const handleReset = () => {
    if (defaults) {
      apiRef.current.setColumnVisibilityModel(defaults)
    }
  }

  return (
    <GridPanelWrapper {...props}>
      <GridColumnsManagement {...rootProps.slotProps?.columnsManagement} disableResetButton />
      {defaults && (
        <Box sx={{ px: 1, pb: 0.5, display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid', borderColor: 'divider' }}>
          <Button size="small" onClick={handleReset}>
            RESET
          </Button>
        </Box>
      )}
    </GridPanelWrapper>
  )
}

export default ColumnsPanel
